module.exports = __webpack_public_path__ + "img/header-avatar.8c2a7ec2.svg";